import { Reveal } from "@/lib/motion";
import { useSiteContent } from "@/lib/useSiteContent";

export default function WhoWeAre() {
  const c = useSiteContent().who_we_are;
  return (
    <section id="who-we-are" data-testid="who-we-are-section" className="section-pad bg-[#FAFAF8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-6">
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-luxe text-[#1D1D1F] text-4xl md:text-5xl leading-[1.08] mt-5">
              {c.heading_line1}
              <br />
              <span className="text-[#B68D40] italic">{c.heading_accent}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-[#616161] leading-relaxed max-w-xl">
              {(c.body_paragraphs || []).map((p, i) => (<p key={i}>{p}</p>))}
              {c.italic_quote && (
                <p className="text-[#1D1D1F] italic font-serif-luxe text-lg md:text-xl">
                  {c.italic_quote}
                </p>
              )}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6 md:pl-8">
          <Reveal>
            <div className="relative overflow-hidden">
              <img
                src={c.image}
                alt="Private wealth advisor"
                data-testid="who-we-are-image"
                className="w-full h-[520px] object-cover hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}